import React from "react";
import logo from "../images/mb-m-500-white.png";

// Flat / brand icons
import adobeIcon from "../images/adobe.svg";
import awsIcon from "../images/aws-brands.svg";
import recordIcon from "../images/record-vinyl-solid.svg";
import metaIcon from "../images/meta-1.svg";
import googleIcon from "../images/Google.svg";
import hubspotIcon from "../images/hubspot-brands.svg";
import jiraIcon from "../images/jira-brands.svg";
import mysqlIcon from "../images/mysql.svg";
import nodeIcon from "../images/node-brands.svg";
import pgIcon from "../images/postgresql.svg";
import reactIcon from "../images/react-brands.svg";
import xeroIcon from "../images/dollar-sign-solid.svg";
import zohoIcon from "../images/zoho.svg";
import openaiIcon from "../images/openai.svg";
import claudeIcon from "../images/claude.svg";
import zhipuIcon from "../images/zhipu.svg";

// Official AWS per-service icons (self-contained colored tiles)
import awsAmplify from "../images/aws/amplify.svg";
import awsApiGateway from "../images/aws/apigateway.svg";
import awsAthena from "../images/aws/athena.svg";
import awsAurora from "../images/aws/aurora.svg";
import awsCloudFront from "../images/aws/cloudfront.svg";
import awsConnect from "../images/aws/connect.svg";
import awsShield from "../images/aws/shield.svg";
import awsWaf from "../images/aws/waf.svg";
import awsDocumentDB from "../images/aws/documentdb.svg";
import awsDynamoDB from "../images/aws/dynamodb.svg";
import awsEcs from "../images/aws/ecs.svg";
import awsLambda from "../images/aws/lambda.svg";
import awsPolly from "../images/aws/polly.svg";
import awsRds from "../images/aws/rds.svg";
import awsCloudFormation from "../images/aws/cloudformation.svg";
import awsStepFunctions from "../images/aws/stepfunctions.svg";
import awsSqs from "../images/aws/sqs.svg";

// `tile: true` -> icon has its own coloured artwork; render it edge-to-edge in the round chip.
// Sorted alphabetically by title.
const apps = [
  { icon: adobeIcon, title: "Adobe" },
  { icon: awsAmplify, title: "Amplify", tile: true },
  { icon: googleIcon, title: "Analytics" },
  { icon: awsApiGateway, title: "API Gateway", tile: true },
  { icon: awsAthena, title: "Athena", tile: true },
  { icon: awsAurora, title: "Aurora", tile: true },
  { icon: openaiIcon, title: "ChatGPT" },
  { icon: awsCloudFormation, title: "CloudFormation", tile: true },
  { icon: awsCloudFront, title: "CloudFront", tile: true },
  { icon: claudeIcon, title: "Claude" },
  { icon: awsConnect, title: "Connect", tile: true },
  { icon: recordIcon, title: "CWR" },
  { icon: recordIcon, title: "DDEX BWARM" },
  { icon: recordIcon, title: "DDEX ERN" },
  { icon: awsIcon, title: "DevOps Agent" },
  { icon: awsDocumentDB, title: "DocumentDB", tile: true },
  { icon: awsDynamoDB, title: "DynamoDB", tile: true },
  { icon: awsEcs, title: "ECS", tile: true },
  { icon: metaIcon, title: "Facebook Ads" },
  { icon: zhipuIcon, title: "GLM" },
  { icon: googleIcon, title: "Google Workspace" },
  { icon: hubspotIcon, title: "Hubspot" },
  { icon: jiraIcon, title: "JIRA" },
  { icon: awsIcon, title: "Kiro" },
  { icon: awsLambda, title: "Lambda", tile: true },
  { icon: metaIcon, title: "Meta Business" },
  { icon: mysqlIcon, title: "MySQL" },
  { icon: nodeIcon, title: "Node" },
  { icon: awsPolly, title: "Polly", tile: true },
  { icon: pgIcon, title: "PostgreSQL" },
  { icon: awsIcon, title: "Quick" },
  { icon: awsRds, title: "RDS", tile: true },
  { icon: reactIcon, title: "React" },
  { icon: googleIcon, title: "Search Console" },
  { icon: awsIcon, title: "Security Agent" },
  { icon: awsShield, title: "Shield", tile: true },
  { icon: awsSqs, title: "SQS", tile: true },
  { icon: awsStepFunctions, title: "Step Functions", tile: true },
  { icon: awsWaf, title: "WAF", tile: true },
  { icon: xeroIcon, title: "Xero" },
  { icon: zohoIcon, title: "Zoho Analytics" },
  { icon: zohoIcon, title: "Zoho CRM" },
];

export default function Applications() {
  return (
    <section className="bg-primary-animated text-gray-100 py-10 md:py-10 px-8">
      <div className="max-w-screen-lg mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-10">
          <img src={logo} alt="" className="w-8 mb-4" />
          <h2 className="text-4xl font-black">Application expertise</h2>
          <p className="mt-4 text-gray-300 max-w-2xl">
            We cover the full spectrum of applications that drive a modern technology business, but the below show some
            of our specialty areas of expertise.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-4 mt-10">
          {apps.map((app, i) => (
            <div key={i} className="flex flex-col items-center text-center py-2 px-2">
              <span className="w-12 h-12 rounded-full overflow-hidden bg-gray-100 flex-shrink-0 flex items-center justify-center">
                <img
                  src={app.icon}
                  alt=""
                  className={app.tile ? "w-full h-full object-cover" : "w-6 h-6"}
                />
              </span>
              <span className="mt-2 text-xs font-bold text-gray-300 leading-tight">{app.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
